import { getField, updateField } from 'vuex-map-fields'
import apiAxios from '../../services/apiAxios'
import moment from 'moment'
import helpers from '../../mixins/helpers'

const state = {
  ventas: [],
  /* Paginacion */
  paginaActual: 1,
  registrosPorPagina: 10,
  totalRegistros: 0,
  totalPaginas: 0,

  ventasSeleccionadas: [],
  seleccionadasPesosCantidad: 0,
  seleccionadasPesosImporte: 0,
  seleccionadasDolaresCantidad: 0,
  seleccionadasDolaresImporte: 0,
  comprobantesSeleccionados: false,
  comprobantesSeleccionadosIndeterminado: false,

  /* Filtro */
  filtroPeriodo: true,
  filtroNumero: false,
  filtroNumeroPresupuesto: false,

  fechaDesde: moment(new Date()).add(-30, 'days').format('YYYY-MM-DD'),
  fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
  cliente: null,
  incluirComprobantesIva: false,
  numeroCertificado: 0,

  numero: 0,
  numeroPuntoVenta: 0,
  comprobanteTipo: null,

  numeroPresupuesto: 0,

  sortByDescending: true,

  rptVentas: [],
  fechaImputacion: '1900-01-01',
}

const mutations = {
  updateField,

  INICIALIZAR_OPCIONES(state) {
    state.ventas = []
    /* Paginacion */
    state.paginaActual = 1
    state.registrosPorPagina = 10
    state.totalRegistros = 0
    state.totalPaginas = 0

    state.ventasSeleccionadas = []
    state.seleccionadasPesosCantidad = 0
    state.seleccionadasPesosImporte = 0
    state.seleccionadasDolaresCantidad = 0
    state.seleccionadasDolaresImporte = 0
    state.comprobantesSeleccionados = false
    state.comprobantesSeleccionadosIndeterminado = false

    /* Filtro */
    state.filtroPeriodo = true
    state.filtroNumero = false
    state.filtroNumeroPresupuesto = false

    state.fechaDesde = moment(new Date()).add(-30, 'days').format('YYYY-MM-DD')
    state.fechaHasta = moment(new Date()).format('YYYY-MM-DD')
    state.cliente = null
    state.incluirComprobantesIva = false
    state.numeroCertificado = 0

    state.numero = 0
    state.numeroPuntoVenta = 0
    state.comprobanteTipo = null

    state.numeroPresupuesto = 0

    state.sortByDescending = true
  },

  INICIALIZAR_VENTAS(state) {
    state.ventas = []
    // state.ventasSeleccionadas = [];
  },
  SET_VENTAS(state, ventas) {
    state.ventas = ventas.map((venta) => ({
      ...venta,
      selected: false,
      _rowVariant: (venta.saldo != 0) & (moment(venta.fechaVencimiento).format('YYYY-MM-DD') < moment(new Date()).format('YYYY-MM-DD')) ? 'danger' : '',
    }))

    if (state.ventasSeleccionadas) {
      state.ventas.forEach((venta) => {
        let itemKey = state.ventasSeleccionadas.findIndex((ventaSeleccionada) => ventaSeleccionada.id == venta.id)

        if (itemKey != -1) {
          venta.selected = true
        }
      })
    }

    validarComprobantesSeleccionados(state)
  },
  SET_PAGINATION(state, params) {
    state.paginaActual = params.paginaActual
    state.registrosPorPagina = params.registrosPorPagina
    state.totalRegistros = params.totalRegistros
    state.totalPaginas = params.totalPaginas
  },

  INICIALIZAR_VENTAS_ELECCIONADAS(state) {
    state.ventasSeleccionadas = []
    state.seleccionadasPesosCantidad = 0
    state.seleccionadasPesosImporte = 0
    state.seleccionadasDolaresCantidad = 0
    state.seleccionadasDolaresImporte = 0
    state.comprobantesSeleccionados = false
    state.comprobantesSeleccionadosIndeterminado = false

    state.ventas.forEach((venta) => (venta.selected = false))
  },
  ADD_VENTA_SELECCIONADA(state, venta) {
    venta.selected = true

    let itemKey = state.ventasSeleccionadas.findIndex((t) => t == venta)

    if (itemKey == -1) {
      state.ventasSeleccionadas.push(venta)
    }

    calcularTotalesSeleccionados(state)
    validarComprobantesSeleccionados(state)
  },
  ACTUALIZAR_VENTA_SELECCIONADA(state, venta) {
    if (venta.selected) {
      let itemKey = state.ventasSeleccionadas.findIndex((ventaSeleccionada) => ventaSeleccionada.id == venta.id)

      if (itemKey == -1) {
        state.ventasSeleccionadas.push(venta)
      }
    } else {
      let itemKey = state.ventasSeleccionadas.findIndex((ventaSeleccionada) => ventaSeleccionada.id == venta.id)

      if (itemKey != -1) {
        state.ventasSeleccionadas.splice(itemKey, 1)
      }
    }

    calcularTotalesSeleccionados(state)
    validarComprobantesSeleccionados(state)
  },
  ACTUALIZAR_SELECCION(state) {
    state.ventas.forEach((venta) => {
      venta.selected = !/true/i.test(state.comprobantesSeleccionados)

      if (!/true/i.test(state.comprobantesSeleccionados)) {
        let itemKey = state.ventasSeleccionadas.findIndex((ventaSeleccionada) => ventaSeleccionada.id == venta.id)

        if (itemKey == -1) {
          state.ventasSeleccionadas.push(venta)
        }
      } else {
        let itemKey = state.ventasSeleccionadas.findIndex((ventaSeleccionada) => ventaSeleccionada.id == venta.id)

        if (itemKey != -1) {
          state.ventasSeleccionadas.splice(itemKey, 1)
        }
      }
    })

    state.comprobantesSeleccionados = !state.comprobantesSeleccionados
    state.comprobantesSeleccionadosIndeterminado = false

    calcularTotalesSeleccionados(state)
  },
  INICIALIZAR_FECHA_IMPUTACION(state) {
    state.fechaImputacion = '1900-01-01'
  },
  SET_FECHA_IMPUTACION(state, fechaImputacion) {
    state.fechaImputacion = moment(fechaImputacion).format('YYYY-MM-DD')
  },

  INICIALIZAR_RPT_VENTAS(state) {
    state.rptVentas = []
  },
  SET_RPT_VENTAS(state, rptVentas) {
    state.rptVentas = rptVentas
  },
}

function validarComprobantesSeleccionados(state) {
  /* Actualizamos el estado del check global */
  let existsComprobanteSeleccionado = false
  let existsComprobanteNoSeleccionado = false

  let comprobanteSeleccionado = state.ventas.find((venta) => /true/i.test(venta.selected) == Boolean(true))
  if (comprobanteSeleccionado) {
    existsComprobanteSeleccionado = true
  }

  /* Validamos segun la moneda del comprobante */
  let comprobanteNoSeleccionado = state.ventas.find((venta) => /true/i.test(venta.selected) == Boolean(false))
  if (comprobanteNoSeleccionado) {
    existsComprobanteNoSeleccionado = true
  }

  state.comprobantesSeleccionados = existsComprobanteSeleccionado
  state.comprobantesSeleccionadosIndeterminado = existsComprobanteSeleccionado & existsComprobanteNoSeleccionado ? true : false
}

function calcularTotalesSeleccionados(state) {
  state.seleccionadasPesosCantidad = 0
  state.seleccionadasPesosImporte = 0
  state.seleccionadasDolaresCantidad = 0
  state.seleccionadasDolaresImporte = 0

  if (state.ventasSeleccionadas.length != 0) {
    state.seleccionadasPesosCantidad = state.ventasSeleccionadas.filter((venta) => venta.monedaId == 101).length
    state.seleccionadasPesosImporte = state.ventasSeleccionadas
      .filter((venta) => venta.monedaId == 101)
      .reduce((total, venta) => {
        if (/true/i.test(venta.credito)) {
          return total - parseFloat(venta.total)
        }
        return total + parseFloat(venta.total)
      }, 0)

    state.seleccionadasDolaresCantidad = state.ventasSeleccionadas.filter((venta) => venta.monedaId == 102).length
    state.seleccionadasDolaresImporte = state.ventasSeleccionadas
      .filter((venta) => venta.monedaId == 102)
      .reduce((total, venta) => {
        if (/true/i.test(venta.credito)) {
          return total - parseFloat(venta.total)
        }
        return total + parseFloat(venta.total)
      }, 0)
  }
}

const getters = {
  getField,

  rptVentas(state) {
    return state.rptVentas
  },
  fechaImputacion(state) {
    return state.fechaImputacion
  },
}

const actions = {
  inicializarOpciones({ commit }) {
    commit('INICIALIZAR_OPCIONES')
  },

  getVentas({ commit }) {
    return new Promise((resolve, reject) => {
      commit('INICIALIZAR_VENTAS')

      let queryString = '?pageSize=' + state.registrosPorPagina + '&pageNumber=' + state.paginaActual + '&sortByDescending=' + state.sortByDescending

      if (/true/i.test(state.filtroNumero)) {
        queryString += '&numero=' + state.numero

        if (state.numeroPuntoVenta != 0) {
          queryString += '&numeroPuntoVenta=' + state.numeroPuntoVenta
        }

        if (state.comprobanteTipo) {
          if (state.comprobanteTipo.id != 0) {
            queryString += '&comprobanteTipoId=' + state.comprobanteTipo.id
          }
        }
      }

      if (/true/i.test(state.filtroNumeroPresupuesto)) {
        queryString += '&presupuestoNumero=' + state.numeroPresupuesto
      }

      if (/true/i.test(state.filtroPeriodo)) {
        queryString += '&fechaDesde=' + moment(state.fechaDesde).format('YYYY-MM-DD') + '&fechaHasta=' + moment(state.fechaHasta).format('YYYY-MM-DD')

        if (state.cliente) {
          if (state.cliente.id != 0) {
            queryString += '&clienteId=' + state.cliente.id
          }
        }
        if (state.numeroCertificado != 0) {
          queryString += '&certificadoServicioId=' + state.numeroCertificado
        }
        if (state.incluirComprobantesIva) {
          queryString += '&incluirComprobantesIva=true'
        }
      }

      apiAxios
        .get('ventas' + queryString)
        .then((res) => {
          if (res.headers.pagination) {
            const pagination = JSON.parse(res.headers.pagination)
            var params = {
              paginaActual: pagination.currentPage,
              registrosPorPagina: pagination.itemsPerPage,
              totalRegistros: pagination.totalItems,
              totalPaginas: pagination.totalPages,
            }
            commit('SET_PAGINATION', params)
          }
          commit('SET_VENTAS', res.data)

          resolve()
        })
        .catch((error) => reject(helpers.methods.getErrorMessage(error)))
    })
  },
  inicializarVentasSeleccionadas({ commit }) {
    return new Promise((resolve, reject) => {
      commit('INICIALIZAR_VENTAS_ELECCIONADAS')
      resolve()
    })
  },
  seleccionarVenta({ commit }, venta) {
    return new Promise((resolve, reject) => {
      commit('ADD_VENTA_SELECCIONADA', venta)
      resolve()
    })
  },
  actualizarVentaSeleccionada({ commit }, venta) {
    return new Promise((resolve, reject) => {
      commit('ACTUALIZAR_VENTA_SELECCIONADA', venta)
      resolve()
    })
  },
  actualizarSeleccion({ commit }) {
    return new Promise((resolve, reject) => {
      commit('ACTUALIZAR_SELECCION')
      resolve()
    })
  },
  delete({}, ventaId) {
    return new Promise((resolve, reject) => {
      apiAxios
        .post(`ventas/${ventaId}/delete`)
        .then(() => resolve())
        .catch((error) => reject(helpers.methods.getErrorMessage(error)))
    })
  },
  cancelar({}, params) {
    return new Promise((resolve, reject) => {
      let ventaCancelacion = {
        observaciones: params.observaciones.trim(),
        anulaFacturaCreditoElectronica: params.anulaFacturaCreditoElectronica,
      }
      apiAxios
        .post(`ventas/${params.ventaId}/cancelar`, ventaCancelacion)
        .then(() => resolve())
        .catch((error) => reject(helpers.methods.getErrorMessage(error)))
    })
  },
  actualizarCAE({}, params) {
    return new Promise((resolve, reject) => {
      let ventaCAE = {
        codigoAutorizacion: params.cae.trim(),
        fechaVencimiento: params.fechaVencimientoCAE,
      }
      apiAxios
        .post(`ventas/${params.ventaId}/actualizar-cae`, ventaCAE)
        .then(() => resolve())
        .catch((error) => reject(helpers.methods.getErrorMessage(error)))
    })
  },
  getFechaImputacion({ commit }, ventaId) {
    return new Promise((resolve, reject) => {
      commit('INICIALIZAR_FECHA_IMPUTACION')

      apiAxios
        .get(`ventas/${ventaId}/fecha-imputacion-indicadores`)
        .then((res) => {
          commit('SET_FECHA_IMPUTACION', res.data)
          resolve()
        })
        .catch((error) => reject(helpers.methods.getErrorMessage(error)))
    })
  },
  actualizarFechaImputacion({}, params) {
    return new Promise((resolve, reject) => {
      let datos = {
        fecha: params.fechaImputacion,
      }
      apiAxios
        .post(`ventas/${params.ventaId}/actualizar-imputacion-indicadores`, datos)
        .then(() => resolve())
        .catch((error) => reject(helpers.methods.getErrorMessage(error)))
    })
  },
  excluirCalculoIndicadores({}, ventaId) {
    return new Promise((resolve, reject) => {
      apiAxios
        .post(`ventas/${ventaId}/excluir-indicadores`)
        .then(() => resolve())
        .catch((error) => reject(helpers.methods.getErrorMessage(error)))
    })
  },
  incluirCalculoIndicadores({}, ventaId) {
    return new Promise((resolve, reject) => {
      apiAxios
        .post(`ventas/${ventaId}/incluir-indicadores`)
        .then(() => resolve())
        .catch((error) => reject(helpers.methods.getErrorMessage(error)))
    })
  },
  deleteNegociacion({}, ventaId) {
    return new Promise((resolve, reject) => {
      apiAxios.post(`ventas/${ventaId}/negociaciones/delete`)
        .then(() => resolve())
        .catch((error) => reject(helpers.methods.getErrorMessage(error)))
    })
  },
  getRptVentas({ commit }, params) {
    return new Promise((resolve, reject) => {
      commit('INICIALIZAR_RPT_VENTAS')

      let queryString = '?fechaDesde=' + moment(params.fechaDesde).format('YYYY-MM-DD') + '&fechaHasta=' + moment(params.fechaHasta).format('YYYY-MM-DD')

      if (params.clienteId) {
        if (params.clienteId != 0) {
          queryString += '&clienteId=' + params.clienteId
        }
      }
      if (params.numeroCertificado != 0) {
        if (params.numeroCertificado != 0) {
          queryString += '&certificadoServicioId=' + params.numeroCertificado
        }
      }

      apiAxios
        .get('ventas/rpt' + queryString)
        .then((res) => {
          commit('SET_RPT_VENTAS', res.data)
          resolve()
        })
        .catch((error) => reject(helpers.methods.getErrorMessage(error)))
    })
  },
  getRptVentasComparativo({ commit }, params) {
    return new Promise((resolve, reject) => {
      commit('INICIALIZAR_RPT_VENTAS')

      let queryString = '?fechaDesde=' + moment(params.fechaDesde).format('YYYY-MM-DD') + '&fechaHasta=' + moment(params.fechaHasta).format('YYYY-MM-DD')

      if (/true/i.test(params.sinReembolsos)) {
        queryString += '&sinReembolsos=true'
      }

      apiAxios
        .get('ventas/rpt/comparativo' + queryString)
        .then((res) => {
          commit('SET_RPT_VENTAS', res.data)
          resolve()
        })
        .catch((error) => reject(helpers.methods.getErrorMessage(error)))
    })
  },
  getRptResumenClientes({ commit }, params) {
    return new Promise((resolve, reject) => {
      commit('INICIALIZAR_RPT_VENTAS')

      let queryString = '?fechaDesde=' + moment(params.fechaDesde).format('YYYY-MM-DD') + '&fechaHasta=' + moment(params.fechaHasta).format('YYYY-MM-DD')

      apiAxios
        .get('ventas/rpt/resumen-clientes' + queryString)
        .then((res) => {
          commit('SET_RPT_VENTAS', res.data)
          resolve()
        })
        .catch((error) => reject(helpers.methods.getErrorMessage(error)))
    })
  },
  getRptEvolucionSemestralClientes({ commit }) {
    return new Promise((resolve, reject) => {
      commit('INICIALIZAR_RPT_VENTAS')

      apiAxios
        .get('ventas/rpt/evolucion-semestral-clientes')
        .then((res) => {
          commit('SET_RPT_VENTAS', res.data)
          resolve()
        })
        .catch((error) => reject(helpers.methods.getErrorMessage(error)))
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
